import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function ContentfulLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="ContentfulLogo">
      <path
        d="M6.85286 13.9809V13.9809C5.79514 12.9262 5.20066 11.494 5.20066 10.0003C5.20066 8.50667 5.79514 7.07443 6.85286 6.01976V6.01976C7.7108 5.16184 7.7108 3.77089 6.85286 2.91297C5.99491 2.05505 4.60391 2.05505 3.74596 2.91297C1.88681 4.80446 0.841409 7.34819 0.833252 10.0003C0.859626 12.6488 1.90234 15.186 3.74596 17.0877C4.30096 17.6427 5.10988 17.8594 5.86801 17.6563C6.62615 17.4531 7.21832 16.861 7.42146 16.1029C7.6246 15.3448 7.40785 14.5359 6.85286 13.9809V13.9809Z"
        fill="#FFD85F"
      />
      <path
        d="M6.85289 6.01941V6.01941C7.90759 4.96172 9.33989 4.36726 10.8336 4.36726C12.3273 4.36726 13.7596 4.96172 14.8143 6.01941V6.01941C15.6723 6.87732 17.0633 6.87732 17.9212 6.01941C18.7791 5.16149 18.7791 3.77053 17.9212 2.91262C16.0296 1.05352 13.4858 0.00815716 10.8336 0C8.18502 0.0263736 5.64776 1.06905 3.746 2.91262C2.88805 3.77053 2.88805 5.16149 3.746 6.01941C4.60394 6.87732 5.99495 6.87732 6.85289 6.01941V6.01941Z"
        fill="#3BB4E7"
      />
      <path
        d="M14.8143 13.9804V13.9804C13.7596 15.0381 12.3273 15.6325 10.8336 15.6325C9.33989 15.6325 7.90759 15.0381 6.85289 13.9804V13.9804C5.99495 13.1225 4.60394 13.1225 3.746 13.9804C2.88805 14.8383 2.88805 16.2293 3.746 17.0872C5.63755 18.9463 8.18136 19.9917 10.8336 19.9998C13.4822 19.9734 16.0194 18.9308 17.9212 17.0872C18.4762 16.5322 18.6929 15.7233 18.4898 14.9652C18.2867 14.2071 17.6945 13.615 16.9364 13.4118C16.1782 13.2087 15.3693 13.4254 14.8143 13.9804V13.9804Z"
        fill="#ED5C68"
      />
      <path
        d="M6.92196 6.04802C7.79372 5.17568 7.79323 3.76181 6.92085 2.89008C6.04848 2.01834 4.63457 2.01883 3.7628 2.89118C2.89103 3.76353 2.89153 5.17739 3.7639 6.04913C4.63628 6.92086 6.05019 6.92037 6.92196 6.04802Z"
        fill="#308BC5"
      />
      <path
        d="M6.91195 17.1047C7.78371 16.2323 7.78322 14.8185 6.91084 13.9467C6.03847 13.075 4.62456 13.0755 3.75279 13.9478C2.88102 14.8202 2.88152 16.234 3.75389 17.1058C4.62627 17.9775 6.04018 17.977 6.91195 17.1047Z"
        fill="#D5465F"
      />
    </LogoSkeleton>
  )
}
